import { adjustmentSessionIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const editAdjustmentSession = {
  name: "editAdjustmentSession" as const,
  input: z.object({
    sessionId: adjustmentSessionIdFormat.schema,
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        newQuantity: z.number().int().nonnegative(),
      }),
    ),
    notes: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), pending: z.boolean().optional() }),
};
